module.exports = __webpack_public_path__ + "media/ko_kr_s1_DongMin.41ab7891.oga";